module.exports = __webpack_public_path__ + "img/samuela.d98163aa.jpg";